import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ["Prepari le lezioni all'ultimo minuto e spesso improvvisi troppo.", 'Alcuni studenti perdono interesse rapidamente e fanno pochi progressi.', 'Ripeti spesso gli stessi esercizi e le lezioni rischiano di diventare monotone.', 'Sai insegnare tango, ma senti di non avere ancora un metodo davvero strutturato e professionale.'];
  return <section className="py-16 md:py-24 bg-white px-4" data-id="element-183">
      <div className="max-w-4xl mx-auto" data-id="element-184">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-stone-900 mb-12" data-id="element-185">
          Ti riconosci in una di queste situazioni?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-186">
          {problems.map((problem, index) => <div key={index} className="bg-red-50 border border-red-100 rounded-2xl p-6 flex items-start space-x-4 shadow-sm" data-id="element-187">
              <XCircleIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-188" />
              <p className="text-lg text-stone-800 font-medium" data-id="element-189">{problem}</p>
            </div>)}
        </div>
      </div>
    </section>;
}